import { isCarvanaNativeApp } from '@carvana/core-native-messaging';
import React from 'react';
import type { KeyboardEvent } from 'react';
import { useSlate } from '|/context';
import sendNativeEvent from '|/helpers/send-native-event';
import Icon from './icon.svg';
import styles from './seven-day-banner.module.css';

const textPrefix =
  'If you don’t love your new ride, you can simply return or exchange it as part of your ';
const linkText = '7‑Day Money Back Guarantee';
const textSuffix = '.';

const sevenDayLink = `${process.env.BASE_URL}/help/purchasing-a-car/what-are-the-limits-of-the-7-day-money-back-guarantee`;

const onClickSevenDayLink = () => {
  const isNativeApp = isCarvanaNativeApp();

  if (isNativeApp) {
    sendNativeEvent({
      event: 'link',
      payload: {
        url: sevenDayLink,
        linkType: 'browser'
      },
      source: 'purchase'
    });
    return;
  }

  window.open(sevenDayLink, '_blank');
};

const onKeyDownSevenDayLink = (event: KeyboardEvent<HTMLSpanElement>) => {
  if (event.key === 'Enter' || event.key === ' ') {
    onClickSevenDayLink();
  }
};

export interface SevenDayBannerProps {
  compact?: boolean;
}

export const SevenDayBanner = ({ compact = false }: SevenDayBannerProps = {}) => {
  const { isSlateVehicle } = useSlate();

  if (isSlateVehicle) {
    return null;
  }

  const iconSize = compact ? '32px' : '48px';
  const containerClassName = compact
    ? `${styles.container} ${styles.containerCompact}`
    : styles.container;

  return (
    <div className={containerClassName}>
      <Icon className={styles.icon} width={iconSize} height={iconSize} />

      <div className={styles.text}>
        {textPrefix}

        <span
          className={styles.link}
          role="link"
          tabIndex={0}
          onClick={onClickSevenDayLink}
          onKeyDown={onKeyDownSevenDayLink}
          data-analytics-id="pp_complete_purchase_pao_seven_day_link"
        >
          {linkText}
        </span>

        {textSuffix}
      </div>
    </div>
  );
};
